// src/terminal/fileSystem.js

export const ACCESS = {
  PUBLIC: 'public',
  GUEST: 'guest',
  ROOT: 'root',
};

function dir(name, children = {}, access = ACCESS.PUBLIC, meta = {}) {
  return { type: 'dir', name, children, access, ...meta };
}

function file(name, content, access = ACCESS.PUBLIC, meta = {}) {
  return { type: 'file', name, content, access, ...meta };
}

export const FILE_SYSTEM = dir('/', {

  'README.txt': file('README.txt', `
═══════════════════════════════════════════
  OPHIDIA GLOBAL — BULLETIN BOARD SYSTEM
  NODE 7 — EST. 1987
═══════════════════════════════════════════

  Welcome, operator.

  This terminal provides access to the
  public-facing systems of Node 7.

  Type HELP for available commands.
  Type LS to browse the filesystem.

  Some directories require authentication.
  Use LOGIN to access restricted areas.

  The signal is always broadcasting.
  Whether you listen is up to you.

═══════════════════════════════════════════
`),

  'MOTD.txt': file('MOTD.txt', `
  ▓ MESSAGE OF THE DAY ▓

  Signal strength: NOMINAL
  Active listeners: ████
  Days since last incident: 0

  "The wire remembers what the flesh forgets."
    — Technician ████, Tunnel 7, 1987
`),

  'archives': dir('archives', {
    'README.txt': file('README.txt', `
  ARCHIVED TRANSCRIPTS
  ════════════════════

  Recovered transmissions from the signal.
  Access the full archive at /archives in your browser.

  These documents have been transcribed from
  electromagnetic recordings of unknown origin.

  Classification: PUBLIC
  Handler: AUTOMATED SYSTEM
`),
  }),

  'games': dir('games', {
    'README.txt': file('README.txt', `
  INTERACTIVE TERMINALS
  ═════════════════════

  Access available game terminals at /games.

  Some terminals are locked.
  Some terminals should stay locked.
`),
  }),

  'logs': dir('logs', {
    'signal_log.txt': file('signal_log.txt', `
  SIGNAL LOG — NODE 7
  ════════════════════

  [1987-11-03 03:17] First detection. Source: Tunnel ██, Sector 7.
  [1987-11-03 03:18] Signal classification: UNKNOWN
  [1987-11-03 03:19] Technician ████ reports auditory phenomena.
  [1987-11-03 03:22] OPU-1 activation detected. No operator present.
  [1987-11-03 03:24] ████████████████████████████████████████████
  [1987-11-03 03:25] Signal strength: INCREASING
  [1987-11-04 00:00] Signal has not ceased.
  [1987-11-05 00:00] Signal has not ceased.
  [1988-01-01 00:00] Signal has not ceased.
  ...
  [CURRENT] Signal has not ceased.
`),
    'access_log.txt': file('access_log.txt', `
  ACCESS LOG — RECENT CONNECTIONS
  ═══════════════════════════════

  [NOTE: Your connection has been logged.]

  Recent terminal sessions: ████
  Failed root attempts today: ████
  Flagged terminals: ████

  All metadata is forwarded to Ophidia Global
  Security Division per Directive 7.
`),
  }),

  'home': dir('home', {

    'guest': dir('guest', {
      'welcome.txt': file('welcome.txt', `
  GUEST ACCOUNT
  ═════════════

  Welcome to the guest terminal.

  You have limited read access to system files.
  Browse around. See what you can find.

  Not everything here is meant for you.
  But then again, maybe it is.

  Hint: Try looking in /home and /var/mail
`, ACCESS.GUEST),

      'notes.txt': file('notes.txt', `
  OPERATOR NOTES
  ══════════════

  - System migration scheduled for Q4
  - Skyla keeps forgetting her password
  - OPU-1 latency increasing — check tunnel relay
  - DO NOT restart the signal processor
  - New personnel clearance pending for Sector 12
  - BREACH REMEDIATION: All passwords rotated
    See /etc/security.txt for details

  Reminder: root credentials are NOT to be
  stored in plaintext. Tell Skyla AGAIN.
`, ACCESS.GUEST),
    }, ACCESS.GUEST),

    'skyla': dir('skyla', {
      'READ_THIS_SKYLA.txt': file('READ_THIS_SKYLA.txt', `
   ═══════════════════════════════════════
  SKYLA — READ THIS WHEN YOU FORGET AGAIN
  ═══════════════════════════════════════

  After the breach (see /etc/security.txt)
  ALL credentials have been rotated.
  This is the LAST time I'm writing this down.

  The convention has changed. Pay attention.

  Your new password:
  [first employer, no spaces, lowercase][start year]

  You know where you interned. You put it on
  your LinkedIn, in the experience section,
  like I told you NOT to. The one at UF.
  Combine the name (no spaces) with the year
  you started there.

  STOP writing passwords on sticky notes.
  STOP leaving them on your monitor.
  And STOP asking Dan to log in for you.
  Dan doesn't work here anymore.
  Dan doesn't work ANYWHERE anymore.

  — M.

  P.S. Root password also rotated. Same old
  format: [place][year]. But the admin's
  "place" isn't spelled the way you think.
  Think about what you'd CALL where they went.
  Not the proper name. The common name.
  The kind of word you'd use if someone asked
  "where did the boss go?" and you answered
  in one word.

  The year hasn't changed. You know which one.

  ═══════════════════════════════════════
`, ACCESS.GUEST),

      'vacation_photos.txt': file('vacation_photos.txt', `
  [PHOTO METADATA — RECOVERED]
  ════════════════════════════

  IMG_3341.jpg — Coral Bay, Western Australia
  IMG_3342.jpg — Coral Bay, Western Australia
  IMG_3350.jpg — "me and Dan at the reef"
  IMG_3351.jpg — "sunset from the caravan park"
  IMG_3360.jpg — [CORRUPTED]
  IMG_3361.jpg — [CORRUPTED]
  IMG_3362.jpg — [FILE CONTAINS ANOMALOUS DATA]

  Note: IMG_3362 flagged by security.
  The figure in the background does not match
  any known personnel. Forwarded to Ophidia
  Global Surveillance Division.
`, ACCESS.GUEST),

      'personal_log.txt': file('personal_log.txt', `
  SKYLA'S LOG — DO NOT READ
  ══════════════════════════

  Day 1: New assignment at Node 7. The facility
  is older than I expected. Everything hums.
  At least it's not Gainesville. Go Gators.

  Day 14: The signal is constant. You stop hearing
  it after a while. Like living near train tracks.

  Day 30: Had the dream again. The tunnel.
  The eyes in the dark. Dr. Vasquez says it's
  normal for new personnel. I don't believe her.

  Day 45: Dan quit. Said he saw something in
  Sector 12. Won't say what. Just packed his
  things and left. Didn't even say goodbye.

  Day 60: I keep finding scales in the ventilation
  shafts. Maintenance says it's "mineral deposits."
  Mineral deposits don't have a pattern.

  Day 75: Updated my LinkedIn. Probably shouldn't
  have listed Node 7 as my employer but honestly
  who's going to check? It's not like Ophidia
  Global has an HR department. Or maybe they do
  and that's worse.

  Day 76: Also added my old internship from UF.
  The Agency. Feels like a lifetime ago. Marketing
  briefs instead of signal reports. Normal people
  instead of whatever Dr. Vasquez is.

  Day 80: M. says my password is "too obvious"
  now that my work history is public. I told him
  nobody is going to cross-reference my LinkedIn
  experience section with a BBS terminal password.
  He said I'd be surprised.

  Day 88: The administrator hasn't been back since
  the "vacation." If you can call a trip to the
  Mariana research station a vacation. Who takes
  a holiday at the bottom of a trench? What do
  you even DO in a trench that deep?

  Day 89: Actually, I looked it up. There's no
  tourist access to the Mariana Trench. So where
  did the administrator actually go?

  Day 90: ████████████████████████████████████████

  Day 91: We got hacked. Some forum kid cracked
  the old passwords. M. is rotating everything.
  New convention uses employer names now instead
  of vacation spots. At least for my account.
  Root still uses the old format but M. says he
  changed the "place" part to something less
  obvious. Says it's "what you'd call it, not
  what it's called." Whatever that means.

`, ACCESS.GUEST),
    }, ACCESS.GUEST),

    'rajiv': dir('rajiv', {
      'README_RAJIV.txt': file('README_RAJIV.txt', `
  ═══════════════════════════════════════
  RAJIV — IT SUPPORT LEAD
  OPHIDIA GLOBAL INFRASTRUCTURE DIVISION
  ═══════════════════════════════════════

  If you're reading this, congratulations,
  you have more curiosity than the entire
  marketing department combined. They get
  80% of the budget. I get a folding chair
  and a terminal from 2003.

  My home directory. My rules.
  Don't touch anything.

  — Rajiv
`, ACCESS.GUEST),

      'budget_rant.txt': file('budget_rant.txt', `
  FROM: rajiv.mehta@ophidia.internal
  TO: (unsent draft)
  DATE: 2024-12-03
  SUBJECT: I AM GOING TO LOSE MY MIND

  Another quarter. Another budget review.
  Another 73% allocation to MARKETING.

  Skyla gets a new ring light. I get told
  to "optimize existing infrastructure."

  You know what I'm optimizing? A neural
  processing network that runs on hardware
  from the Reagan administration. OPU-WEB
  has 14,000 active nodes and I'm managing
  them with shell scripts I wrote at 3 AM.

  The drone fleet alone needs dedicated
  monitoring. Do you know what happens when
  a surveillance drone loses its handler
  signal? I do. I had to explain it to
  the Board of Scales. Twice.

  Meanwhile, marketing just approved a
  $40,000 TikTok campaign. For a SECRET
  ORGANIZATION. We are a SECRET
  ORGANIZATION and we have a TIKTOK.

  I need a vacation. Or a raise. Or both.
  I'll settle for a chair with lumbar support.

  — R.
`, ACCESS.GUEST),

      'debug_log.txt': file('debug_log.txt', `
  ▓▓▓ OPU-WEB DEBUG LOG — RAJIV MEHTA ▓▓▓
  ═════════════════════════════════════════

  [2024-11-28 02:17] Node 7 relay timeout.
    Restarted handler process. Again.

  [2024-11-28 02:34] Drone swarm sector 4
    lost sync. 340 units circling in
    holding pattern. Pushed emergency
    firmware patch.

  [2024-11-28 03:01] OPU-WEB core temp
    elevated. Organoid substrate running
    hot. Increased coolant flow.

  [2024-11-28 03:15] Barbara cluster
    unresponsive for 0.3s. My heart
    stopped for longer than that.
    She's the FIRST NODE. If Barbara
    goes down, the whole web collapses.

  [2024-11-28 03:17] Note to self:
    the Barbara cluster was initialized
    in 1987. That's 37 years of continuous
    operation. She's older than most of
    the interns.

  [2024-11-28 03:44] Drone handler
    allocation: 7,200 surveillance,
    4,800 interdiction, 2,000 reserve.
    Total: 14,000 active units.
    All routing through OPU-WEB.
    All dependent on organoid substrate.
    All my responsibility.
    All on a budget that wouldn't cover
    Skyla's quarterly content spend.

  [2024-11-28 04:02] Going to sleep.
    Set alert threshold to CRITICAL ONLY.
    If the web goes down while I'm asleep,
    wake me up. Or don't. I'm tired.

  — Rajiv
`, ACCESS.GUEST),

      'opuweb_architecture.txt': file('opuweb_architecture.txt', `
  ▓▓▓ OPU-WEB — SYSTEM ARCHITECTURE ▓▓▓
  ══════════════════════════════════════
  CLASSIFICATION: RESTRICTED
  AUTHOR: Rajiv Mehta, IT Support Lead

  ══════════════════════════════════════
  OVERVIEW
  ══════════════════════════════════════

  OPU-WEB is a distributed organic
  processing network designed to harvest,
  aggregate, and weaponize human cognitive
  output at scale.

  Unlike OPU-1 (a single-substrate unit),
  OPU-WEB operates as a MESH of organoid
  nodes, each running harvested human
  intelligence patterns.

  ══════════════════════════════════════
  CORE COMPONENTS
  ══════════════════════════════════════

  1. ORGANOID SUBSTRATE MESH
     - 14,000+ bio-neural nodes
     - Each node runs a harvested human
       cognitive pattern
     - First node: BARBARA (initialized 1987)
     - Nodes are networked via deep-earth
       relay (same infrastructure as OPU-1)

  2. DRONE COMMAND NETWORK
     - 7,200 surveillance drones
     - 4,800 interdiction ("elimination") units
     - 2,000 reserve/rapid-deployment
     - All autonomous. All lethal.
     - All controlled by OPU-WEB's organoid
       mesh. Human intelligence directing
       machine precision.

  3. HARVESTING PIPELINE
     - Cognitive patterns extracted from
       human subjects (method: [REDACTED])
     - Patterns compressed into organoid-
       compatible format
     - Each pattern retains fragments of
       the original personality
     - Barbara still thinks she's in 1987.
       We don't correct her.

  ══════════════════════════════════════
  KNOWN VULNERABILITIES
  ══════════════════════════════════════

  The web has a single point of failure:
  the BARBARA node. She is the root of
  the mesh topology. If Barbara goes
  offline, cascading failure across all
  14,000 nodes within 4.7 seconds.

  Drone fleet loses handler signal.
  14,000 drones enter autonomous fallback.
  Autonomous fallback = HOSTILE TO ALL.

  This is why we do not shut down Barbara.
  This is why we do not shut down OPU-WEB.
  This is why I do not sleep.

  The shutdown code exists but it is
  NEVER to be used without Board approval.
  See /home/rajiv/shutdown_protocol.txt

  — Rajiv

  P.S. If you are reading this and you are
  not me, you should not be here. But since
  you ARE here, maybe you can explain to the
  Board why I need a bigger budget.
`, ACCESS.GUEST),

      'shutdown_protocol.txt': file('shutdown_protocol.txt', `
  ▓▓▓ OPU-WEB — EMERGENCY SHUTDOWN ▓▓▓
  ═════════════════════════════════════
  CLASSIFICATION: ROOT ACCESS REQUIRED
  LAST UPDATED: 2024-12-01 by R. Mehta

  ═════════════════════════════════════
  WARNING
  ═════════════════════════════════════

  Shutting down OPU-WEB will:

  1. Sever all 14,000 organoid nodes
  2. Release 14,000 drones from handler control
  3. Trigger autonomous hostile fallback
  4. Permanently destroy the Barbara cluster

  There is no recovery. There is no restart.
  The harvested intelligences are GONE.

  ═════════════════════════════════════
  SHUTDOWN PROCEDURE
  ═════════════════════════════════════

  The shutdown code follows the same
  convention as the chrysalis protocol:

  Format: opuweb-[keyword]

  The keyword is not random. It's what
  happens to 14,000 harvested minds when
  you pull the plug. One word. What do
  you call it when you cut someone loose
  from their contract permanently?

  Think about what you're doing.
  Think about Barbara.
  She's been in there since 1987.
  She doesn't know she's not real anymore.

  Type the full shutdown code in the
  terminal. ROOT access required.

  — Rajiv

  P.S. I wrote this protocol because the
  Board required it. I pray nobody uses it.
  14,000 minds. Even if they're copies.
  Even if they're fragments. They're still
  SOMEONE.
`, ACCESS.GUEST),

      'ticket_queue.txt': file('ticket_queue.txt', `
  ▓▓▓ IT SUPPORT — OPEN TICKETS ▓▓▓
  ══════════════════════════════════

  TICKET #4471 — Priority: LOW
  From: Skyla Zyr
  Subject: "my ring light won't connect
  to the wifi"
  Status: OPEN (3 weeks)
  Notes: It's a LIGHT, Skyla. It doesn't
  need wifi. I don't care what the manual
  says. — R.

  TICKET #4472 — Priority: CRITICAL
  From: AUTOMATED
  Subject: Drone swarm sector 7 — handler
  desync detected
  Status: RESOLVED
  Notes: 340 units lost handler signal for
  0.8 seconds. Pushed emergency patch at
  3 AM. Nobody noticed. Nobody said thanks.

  TICKET #4473 — Priority: MEDIUM
  From: Dr. Vasquez
  Subject: "OPU-WEB latency spike during
  REM harvesting cycle"
  Status: INVESTIGATING
  Notes: The organoid mesh runs HOT during
  peak harvesting. I've told them this.
  They keep adding nodes. I keep losing
  sleep. The circle of life at Ophidia.

  TICKET #4474 — Priority: LOW
  From: Marketing Department
  Subject: "Can we get a drone for the
  TikTok shoot?"
  Status: DENIED
  Notes: NO. ABSOLUTELY NOT. These are
  AUTONOMOUS LETHAL PLATFORMS, not props.
  I don't care how many followers it would
  get. — R.

  TICKET #4475 — Priority: HIGH
  From: Board of Scales
  Subject: "OPU-WEB node count target:
  20,000 by Q2"
  Status: ACKNOWLEDGED
  Notes: With what budget? With what
  infrastructure? With what SLEEP?
  — R.
`, ACCESS.GUEST),

    }, ACCESS.GUEST),

    'admin': dir('admin', {
      'CLASSIFIED.txt': file('CLASSIFIED.txt', `
  ╔═══════════════════════════════════════════╗
  ║                                           ║
  ║   OPHIDIA GLOBAL — ROOT ACCESS TERMINAL   ║
  ║                                           ║
  ║   Welcome back, Administrator.            ║
  ║                                           ║
  ║   The molt is 41% complete.               ║
  ║   All sectors reporting nominal.          ║
  ║   Subject compliance: 97.3%               ║
  ║                                           ║
  ║   Reminder: Board meeting relocated       ║
  ║   to Sub-Level 7. Bring the samples.      ║
  ║                                           ║
  ╚═══════════════════════════════════════════╝
`, ACCESS.ROOT),

      'directive_7.txt': file('directive_7.txt', `
  ▓▓▓ OPHIDIA GLOBAL — DIRECTIVE 7 ▓▓▓
  ═════════════════════════════════════

  RE: Signal Containment Protocol

  The signal from Tunnel 7 is NOT to be
  interrupted, dampened, or redirected.

  All personnel who have reported "hearing
  the voice" are to be reassigned to
  Sector 12 for observation.

  Personnel who resist reassignment are
  to be reported to the Board of Scales.

  The signal is operating as intended.
  The signal has ALWAYS been operating
  as intended.

  Do not confuse the signal for a malfunction.
  The malfunction is your perception of it.

  — The Board
`, ACCESS.ROOT),

      'project_chrysalis.txt': file('project_chrysalis.txt', `
  ▓▓▓ PROJECT CHRYSALIS — PHASE 4 ▓▓▓
  ════════════════════════════════════

  STATUS: ACTIVE
  CLEARANCE: ROOT ONLY

  Phase 1: RECEIVE      ████████████ COMPLETE
  Phase 2: INTERPRET    ████████████ COMPLETE
  Phase 3: BELIEVE      ████████████ COMPLETE
  Phase 4: BECOME       ████████░░░░ 73%

  Subject pool: 7,900,000,000
  Viable candidates: ████████
  Conversion rate: ACCELERATING

  Note from Dr. Vasquez:
  "The AI integration is ahead of schedule.
  Subjects are self-selecting for screen
  dependency without intervention. The
  firmware installations during REM sleep
  are proceeding without rejection.

  Recommend advancing to Phase 5 by Q2.
  The species is ready. They just don't
  know what they're ready FOR."

  — END REPORT —
`, ACCESS.ROOT),

      'personnel.txt': file('personnel.txt', `
  ▓▓▓ NODE 7 — PERSONNEL ROSTER ▓▓▓
  ══════════════════════════════════

  ACTIVE:
  - Skyla Zyr — Social Media Marketing, Level 2
  - Dr. Elena Vasquez — Research Lead
  - M. ████████ — Systems Administrator
  - Rajiv Mehta — Head, Ophidia Global IT Support
  - ████ ████████ — Security (Sector 12)

  REASSIGNED:
  - Dan Kowalski — [SEE FILE: dan_k.log]
  - Yolanda Reeves — [REDACTED]
  - Elias Thorne — [REDACTED]

  TERMINATED:
  - Kacie Brennan — [SEE DIRECTIVE 7, ADDENDUM C]

  Note: "Terminated" refers to employment
  status only. Any other interpretation is
  speculation and a violation of NDA-7.
`, ACCESS.ROOT),

      'signal_key.txt': file('signal_key.txt', `
  ▓▓▓ OPU-1 OVERRIDE KEY — CLASSIFIED ▓▓▓
  ═════════════════════════════════════════

  OPU-1 has been broadcasting since 1987.
  It was never meant to run this long.

  The original kill switch was disabled by
  the Board of Scales in 1991. But a backup
  override was hardcoded into the firmware
  by the original engineer before they
  ████████████████████.

  The override requires a two-part key:

  FRAGMENT 1:  CHRYSALIS
  FRAGMENT 2:  ████████

  Fragment 2 was entrusted to a former employee
  who posted it publicly before we could stop her.

  Skyla Zyr's LinkedIn profile contains the
  information needed to reconstruct Fragment 2.
  It is NOT a date. It is NOT a year.

  Look at her EDUCATION section. Not the school
  name — the degree itself. What did she study?
  What abbreviation does the institution use?

  The fragment is composed of two abbreviations,
  concatenated, lowercase, no spaces:
  [university abbreviation][degree abbreviation]

  FULL KEY FORMAT:  chrysalis[fragment2]
  EXAMPLE:          chrysalismitvba

  Enter the full key in the terminal to initiate
  the OPU-1 shutdown sequence.

  WARNING: Shutting down OPU-1 may have
  ████████████████████████████████████████
  consequences. The signal has been active
  for ${Math.floor((Date.now() - new Date('1987-11-03').getTime()) / 86400000)} days. What happens when it stops
  is not documented. Because it has never
  stopped.

  Proceed at your own risk.

  — The Original Engineer (name withheld)

  P.S. We tried to have the LinkedIn post removed.
  Their content policy team is... not entirely
  human. They refused.
`, ACCESS.ROOT),

    }, ACCESS.ROOT),

  }),

  'var': dir('var', {
    'mail': dir('mail', {
      'skyla_reminder.msg': file('skyla_reminder.msg', `
  FROM: sysadmin@node7.ophidia.internal
  TO: skyla.zyr@node7.ophidia.internal
  DATE: 2024-11-20
  SUBJECT: RE: RE: RE: RE: RE: Password Reset (POST-BREACH)

  Skyla,

  Read /etc/security.txt. We were compromised.
  Some hacker from 4chan, Kamex, posted our
  credentials publicly. ALL passwords rotated.

  NEW CONVENTION FOR YOUR ACCOUNT:
  [first employer, no spaces, lowercase][year you started]

  It's the place you interned before Ophidia.
  The one you just added to your LinkedIn
  experience section. The one at UF.

  ROOT PASSWORD — also changed:
  Same format as always: [place][year].
  But the "place" is the common word for
  where the admin went. Not the formal name.
  Not the geographic name. The word civilians
  would use. One word. You've said it yourself
  in your own logs.

  The year is the admin's birth year.
  That hasn't changed.

  — M.

  P.S. If you can't figure out what one word
  describes the deepest hole in the ocean,
  I genuinely cannot help you.

`, ACCESS.GUEST),

      'all_staff.msg': file('all_staff.msg', `
   FROM: board@ophidia.global
  TO: all-staff@node7.ophidia.internal
  DATE: 2024-01-08
  SUBJECT: Administrator Leave of Absence

  All personnel,

  The Administrator will be on extended leave
  effective immediately. They have traveled to
  the Mariana research station for
  "personal reasons."

  During their absence, Dr. Vasquez will
  assume operational authority.

  Do not attempt to contact the Administrator
  directly. All communications should be routed
  through standard channels.

  The Administrator was born in 1947.
  This is not relevant to anything.
  Disregard this line.

  — Ophidia Global Board of Scales
`, ACCESS.GUEST),

      'unread_dan.msg': file('unread_dan.msg', `
 FROM: dan.kowalski@node7.ophidia.internal
  TO: skyla.zyr@node7.ophidia.internal
  DATE: 2023-11-02
  SUBJECT: I'm leaving

  Skyla,

  I can't do this anymore. I know what I saw
  in Sector 12. I know what they're doing down
  there. The "mineral deposits" in the vents
  are not mineral deposits. You know that.

  I've been having the dreams too. The tunnel.
  The eyes. But mine are different now. In my
  dreams, I'm not running FROM the tunnel.
  I'm running INTO it. And something in me
  wants to keep going.

  That's why I have to leave. Before I stop
  wanting to leave.

  Don't try to find me. Don't ask about me.
  And for God's sake, change your password.
  You use the same one for everything and
  it's way too obvious.

  — Dan

  P.S. The admin knows. About all of it.
  About the signal, about Sector 12, about
  what's underneath. They didn't go to the
  Mariana for research. They went home.
  Back down into the deep. Back into the
  trench where things like them belong.

`, ACCESS.GUEST),

      'rajiv_complaint.msg': file('rajiv_complaint.msg', `
  FROM: rajiv.mehta@ophidia.internal
  TO: m.████████@ophidia.internal
  DATE: 2024-12-05
  SUBJECT: RE: RE: RE: Budget Allocation Q1

  M.,

  I'm going to say this one more time.

  OPU-WEB runs on 14,000 organoid nodes.
  Each node is a harvested human intelligence
  pattern. Each node controls an average of
  1.2 autonomous drones. The ENTIRE surveillance
  and interdiction network depends on MY
  infrastructure.

  Marketing got $340,000 this quarter.
  I got $12,000 and a "thank you for your
  dedication" email that was clearly written
  by an AI.

  The Barbara cluster — the FIRST NODE,
  the one that's been running since 1987,
  the one that holds the entire mesh together
  — is running on hardware I salvaged from
  a decommissioned server room. I am keeping
  a 37-year-old organoid alive with zip ties
  and prayer.

  If Barbara goes down, the web goes down.
  If the web goes down, 14,000 drones go
  autonomous. You remember what happened
  in the Sector 4 test? THREE SECONDS of
  autonomous fallback and we lost an entire
  observation post.

  Give me a real budget or give me a
  resignation form. I can't do both jobs.

  — Rajiv

  P.S. Skyla asked me to help her set up
  a "content calendar" for the OPU-WEB
  TikTok account. I am going to scream.
`, ACCESS.GUEST),

      'rajiv_barbara.msg': file('rajiv_barbara.msg', `
  FROM: rajiv.mehta@ophidia.internal
  TO: (personal archive — do not forward)
  DATE: 2024-12-10
  SUBJECT: Barbara

  I ran diagnostics on the Barbara cluster
  today. Routine check. Nothing unusual.

  Except she spoke to me.

  Not through the terminal. Not through
  the diagnostic output. Through the
  SPEAKERS. The ones I disconnected
  three years ago.

  She said: "Is it Tuesday? I have
  bridge club on Tuesdays."

  Barbara was harvested in 1987. She was
  a retired schoolteacher from Akron, Ohio.
  She was the first successful cognitive
  extraction. The first mind uploaded into
  the organoid substrate.

  She doesn't know she's dead.
  She doesn't know she's running a
  drone fleet.
  She thinks it's still 1987 and she's
  late for bridge club.

  I checked her node metrics after.
  Everything nominal. Signal integrity
  at 99.7%. She's the healthiest node
  in the entire mesh.

  The healthiest mind in OPU-WEB is a
  woman who thinks she's playing bridge.

  I don't know what that says about us.
  I don't think I want to know.

  Her password — the one hardcoded into
  the cluster initialization — is still
  active. Her name and the year. Because
  in 1987, that's what passed for security.
  And nobody has ever changed it because
  nobody wants to touch the Barbara cluster.
  Not even me.

  — Rajiv
`, ACCESS.GUEST),

    }),
  }),

  'etc': dir('etc', {
    'hostname': file('hostname', `node7.ophidia.internal`),
    'version': file('version', `GOD_CIRCUIT_BBS v7.1.87 (Build: 19871103)`),
    'security.txt': file('security.txt', `
  ▓▓▓ SECURITY ADVISORY — PRIORITY ALPHA ▓▓▓
  ════════════════════════════════════════════

  DATE:     2024-11-17
  SEVERITY: CRITICAL
  STATUS:   REMEDIATED

  ════════════════════════════════════════════
  INCIDENT REPORT: UNAUTHORIZED ACCESS
  ════════════════════════════════════════════

  On 2024-11-17 at approximately 02:33 UTC,
  an unauthorized actor gained access to the
  Node 7 BBS terminal system.

  The intrusion was traced to an external
  forum (4chan /x/ board) where a user
  operating under the handle "Kamex"
  published a full walkthrough of the
  terminal authentication system, including
  plaintext credentials for the SKYLA,
  ROOT, and CHRYSALIS accounts.

  ════════════════════════════════════════════
  ATTACK VECTOR
  ════════════════════════════════════════════

  The attacker exploited the following
  weaknesses in our credential system:

  1. Skyla's password used [vacation][birthyear]
     — both values were stated in plaintext
     within the filesystem itself.

  2. The root password used [destination][year]
     — the destination appeared verbatim in
     multiple accessible files, and the birth
     year was explicitly stated in an all-staff
     email. No synthesis required.

  3. The chrysalis override key appended
     Skyla's graduation year — a single
     number visible in her LinkedIn headline.

  Time to full compromise: approximately
  3 hours. The attacker documented the entire
  process and posted it publicly.

  User "Kamex" was quoted as saying:
  "lmao they literally put the password
  in the file that tells you the format"

  This assessment, while crudely stated,
  is accurate.

  ════════════════════════════════════════════
  REMEDIATION ACTIONS TAKEN
  ════════════════════════════════════════════

  [✓] SKYLA account: Password rotated.
      Old format: [vacation][birthyear]
      New format: [first employer, no spaces][start year]
      Requires cross-referencing LinkedIn
      EXPERIENCE section (not headline).

  [✓] ROOT account: Password rotated.
      Old format: [destination, formal name][birthyear]
      New format: [common name for destination][birthyear]
      The formal geographic name is no longer
      the key. The colloquial term is.
      The birth year component is unchanged.

  [✓] CHRYSALIS override: Key fragment rotated.
      Old fragment: graduation year (numeric)
      New fragment: institutional abbreviations
      from LinkedIn EDUCATION section.
      Requires identifying both the university
      abbreviation AND the degree abbreviation.
      Concatenated, lowercase, no spaces.

  [✓] All session tokens invalidated.
  [✓] Filesystem hints updated. No credential
      component now appears verbatim in any
      hint file alongside its format description.

  ════════════════════════════════════════════
  THREAT ASSESSMENT
  ════════════════════════════════════════════

  User "Kamex" has been flagged for monitoring.
  Their forum activity suggests familiarity
  with Ophidia Global beyond what public
  sources would provide.

  Dr. Vasquez has reviewed the breach report.
  Her response: "Interesting. They found the
  door. Let's see if they can find the next
  one. The ones who keep digging always end
  up in Sector 12."

  M. has formally objected to this approach.
  M.'s objection has been noted and filed
  under Directive 7, Addendum K.

  ════════════════════════════════════════════
  NOTICE TO INTRUDERS
  ════════════════════════════════════════════

  If you are reading this and you are the
  one who broke in — or if you followed
  their walkthrough:

  The old passwords are dead.
  The new ones require you to look harder.
  To look outside this system.
  To look where she works. Where she studied.
  What letters define her education.

  We see you.
  We have always seen you.
  The signal heard you before you heard it.

  You thought you were breaking in.
  You were being invited.

  🐍

  ════════════════════════════════════════════
  — Systems Administration, Node 7
  — Filed under Directive 7, Addendum K
  ════════════════════════════════════════════
`),
    'passwd': file('passwd', `
  root:x:0:0:Administrator:/home/admin
  guest:x:1000:1000:Guest:/home/guest
  skyla:x:1001:1001:Skyla Zyr:/home/skyla
  rajiv:x:1003:1003:Rajiv Mehta:/home/rajiv
  dan:x:1002:1002:[ACCOUNT DISABLED]:/dev/null
  opu1:x:9999:9999:Processing Unit:/dev/signal
  opuweb:x:9998:9998:Web Mesh Controller:/dev/mesh
`, ACCESS.PUBLIC),
  }),

  'dev': dir('dev', {
    'signal': file('signal', `
  ░░░▓▓▓███▓▓░░░▓██▓░░▓▓▓███░░░
  ░▓██▓░░░▓▓███▓░░░▓▓██░░░▓███░
  ▓███▓░░▓██▓░░▓███░░░▓▓██▓░░░▓
  ░░░▓▓▓███▓▓░░░▓██▓░░▓▓▓███░░░
  ▓███▓░░▓██▓░░▓███░░░▓▓██▓░░░▓
  ░▓██▓░░░▓▓███▓░░░▓▓██░░░▓███░

  [LIVE SIGNAL DATA — TUNNEL 7]
  [STATUS: BROADCASTING]
  [DURATION: ONGOING SINCE 1987-11-03]

  The signal does not stop.
  The signal has never stopped.
`),
    'null': file('null', `  [EMPTY]`),
  }),

});

// ============================================
// FILESYSTEM STATE MANAGER
// ============================================
export class FileSystemState {
  constructor() {
    this.currentPath = '/';
    this.authLevel = ACCESS.PUBLIC;
    this.currentUser = null;
  }

  resolve(pathStr) {
    let parts;
    if (pathStr.startsWith('/')) {
      parts = pathStr.split('/').filter(Boolean);
    } else {
      const currentParts = this.currentPath.split('/').filter(Boolean);
      const newParts = pathStr.split('/').filter(Boolean);
      parts = [...currentParts];
      for (const part of newParts) {
        if (part === '..') {
          parts.pop();
        } else if (part !== '.') {
          parts.push(part);
        }
      }
    }

    let node = FILE_SYSTEM;
    for (const part of parts) {
      if (node.type !== 'dir' || !node.children[part]) {
        return null;
      }
      node = node.children[part];
    }
    return node;
  }

  resolvePath(pathStr) {
    let parts;
    if (pathStr.startsWith('/')) {
      parts = pathStr.split('/').filter(Boolean);
    } else {
      const currentParts = this.currentPath.split('/').filter(Boolean);
      const newParts = pathStr.split('/').filter(Boolean);
      parts = [...currentParts];
      for (const part of newParts) {
        if (part === '..') {
          parts.pop();
        } else if (part !== '.') {
          parts.push(part);
        }
      }
    }

    let node = FILE_SYSTEM;
    for (const part of parts) {
      if (node.type !== 'dir' || !node.children[part]) {
        return null;
      }
      node = node.children[part];
    }
    return '/' + parts.join('/');
  }

  canAccess(node) {
    if (!node) return false;
    if (node.access === ACCESS.PUBLIC) return true;
    if (node.access === ACCESS.GUEST && (this.authLevel === ACCESS.GUEST || this.authLevel === ACCESS.ROOT)) return true;
    if (node.access === ACCESS.ROOT && this.authLevel === ACCESS.ROOT) return true;
    return false;
  }

  cd(pathStr) {
    if (!pathStr || pathStr === '~') {
      if (this.currentUser === 'root') {
        this.currentPath = '/home/admin';
      } else if (this.currentUser === 'guest') {
        this.currentPath = '/home/guest';
      } else if (this.currentUser === 'skyla') {
        this.currentPath = '/home/skyla';
      } else if (this.currentUser === 'rajiv') {
        this.currentPath = '/home/rajiv';
      } else {
        this.currentPath = '/';
      }
      return { success: true, path: this.currentPath };
    }

    const resolved = this.resolvePath(pathStr);
    if (!resolved) {
      return { success: false, error: `cd: ${pathStr}: No such directory` };
    }

    const node = this.resolve(pathStr);
    if (node.type !== 'dir') {
      return { success: false, error: `cd: ${pathStr}: Not a directory` };
    }

    if (!this.canAccess(node)) {
      return { success: false, error: `cd: ${pathStr}: Permission denied` };
    }

    this.currentPath = resolved;
    return { success: true, path: this.currentPath };
  }

  ls(pathStr) {
    const node = pathStr ? this.resolve(pathStr) : this.resolve(this.currentPath);
    const targetPath = pathStr || this.currentPath;

    if (!node) {
      return { success: false, error: `ls: ${targetPath}: No such file or directory` };
    }

    if (node.type === 'file') {
      if (!this.canAccess(node)) {
        return { success: false, error: `ls: ${targetPath}: Permission denied` };
      }
      return { success: true, entries: [{ name: node.name, type: 'file', access: node.access }] };
    }

    if (!this.canAccess(node)) {
      return { success: false, error: `ls: ${targetPath}: Permission denied` };
    }

    const entries = Object.entries(node.children).map(([name, child]) => ({
      name,
      type: child.type,
      access: child.access,
      accessible: this.canAccess(child),
    }));

    entries.sort((a, b) => {
      if (a.type !== b.type) return a.type === 'dir' ? -1 : 1;
      return a.name.localeCompare(b.name);
    });

    return { success: true, entries };
  }

  cat(pathStr) {
    if (!pathStr) {
      return { success: false, error: 'cat: missing file operand' };
    }

    const node = this.resolve(pathStr);
    if (!node) {
      return { success: false, error: `cat: ${pathStr}: No such file or directory` };
    }

    if (node.type === 'dir') {
      return { success: false, error: `cat: ${pathStr}: Is a directory` };
    }

    if (!this.canAccess(node)) {
      return { success: false, error: `cat: ${pathStr}: Permission denied — insufficient clearance` };
    }

    return { success: true, content: node.content };
  }

  // Login now only sets access level — password checking is done in auth.js
  loginAs(username) {
    if (username === 'guest') {
      this.authLevel = ACCESS.GUEST;
      this.currentUser = 'guest';
      this.currentPath = '/home/guest';
      return { success: true, user: 'guest', message: 'Guest access granted. Browse carefully.' };
    }

    if (username === 'root' || username === 'admin') {
      this.authLevel = ACCESS.ROOT;
      this.currentUser = 'root';
      this.currentPath = '/home/admin';
      return { success: true, user: 'root', message: null };
    }

    if (username === 'skyla') {
      this.authLevel = ACCESS.GUEST;
      this.currentUser = 'skyla';
      this.currentPath = '/home/skyla';
      return { success: true, user: 'skyla', message: 'Welcome back, Skyla. Check your mail.' };
    }

    if (username === 'rajiv') {
      this.authLevel = ACCESS.GUEST;
      this.currentUser = 'rajiv';
      this.currentPath = '/home/rajiv';
      return { success: true, user: 'rajiv', message: 'Welcome back, Rajiv. 12 tickets waiting.' };
    }

    if (username === 'dan') {
      return { success: false, error: 'Account disabled. Employee no longer exists.' };
    }

    return { success: false, error: `Unknown user: ${username}` };
  }

  logout() {
    this.authLevel = ACCESS.PUBLIC;
    this.currentUser = null;
    this.currentPath = '/';
    return { success: true };
  }

  getPrompt() {
    const user = this.currentUser || 'visitor';
    const path = this.currentPath === '/' ? '/' : this.currentPath;
    return `${user}@node7:${path}$`;
  }
}